import React from "react";
import PropsType from "prop-types";
import { Input } from "antd";

const { Search } = Input;

function ContentSearch(props) {
  const { onSearch, loading = false } = props;

  return (
    <div className="ContentSearch">
      <Search
        size="large"
        enterButton
        addonBefore={""}
        placeholder="جستجو..."
        allowClear={true}
        onSearch={onSearch}
        loading={loading}
      />
    </div>
  );
}

ContentSearch.propTypes = {
  allowClear: PropsType.bool,
};

ContentSearch.defaultProps = {
  allowClear: false,
};

export default ContentSearch;
